<template lang="pug">

      div
        v-toolbar.py-4(height="90" dark="", flat, color="primary" fixed)
          //-v-toolbar-title Video suchen
          //-v-spacer
          div.d-flex.flex-row.justify-space-between(style="width: 100%")
            v-text-field(
              flat
              :label="$t(`search.actionTitle`)",
              prepend-inner-icon="search",
              solo-inverted="",
              v-model="search",           
              clearable="",
              @click:clear="clearSearch",
              v-on:keyup.enter="searchVideos"
              @input="searchTermChanged()"
              autofocus
            )
            v-btn.searchBtn.ml-4.flex-grow-0(
              outlined
              large
              color="white"
              @click="searchVideos()"
            ) {{$t(`search.actionTitle`)}}
        
        div.pb-8.pt-2(:class="{scrollContainer: element }" v-if="(foundVideos.length > 0 && !loading && search)")
            FoundVideoListItem(:videos="foundVideos" :buttonOrigin="buttonOrigin")
        div.pb-8.pt-2(:class="{scrollContainer: element }" v-if=" !loading && allVideosFilteredByElement.length > 0 && !search")
            FoundVideoListItem(:videos="allVideosFilteredByElement" :buttonOrigin="buttonOrigin")
        .text-center(v-if="loading")
          v-progress-circular.mx-auto.my-4(indeterminate color="primary")
        
        v-card-text(v-if="foundVideos.length === 0 && !loading && search && searching")
          v-alert.mt-4(icon="mdi-file-find", prominent, text, color="grey") {{$t('search.noDataFound')}}
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { VideoStatus } from "../../models";
import urlFormat from "@/utils/urlFormat";
import FoundVideoListItem from "./FoundVideoListItem";
import VideoStatusIcons from "@/components/video/VideoStatusIcons";
import { debounce } from "debounce";

export default {
  props: ["element", "buttonOrigin"],
  components: {
    VideoStatusIcons,
    FoundVideoListItem,
  },
  data() {
    return {
      VideoStatus,
      dialog: false,
      searching: false,
      playVideo: false,
      search: "",
    };
  },
  computed: {
    ...mapGetters("search", {
      matchingVideoAssets: "matchingVideoAssets",
    }),
    ...mapGetters("videoAsset", { allVideos: "allVideoAssets" }),
    ...mapState({
      loading: (state) => state.search.loading,
      searchTerm: (state) => state.search.term,
    }),
    foundVideos() {
      return this.element
        ? this.matchingVideoAssets.filter(
            (video) => video.element === this.element
          )
        : this.matchingVideoAssets;
    },
    allVideosFilteredByElement() {
      return this.element
        ? this.allVideos.filter((video) => video.element === this.element)
        : this.allVideos;
    },
  },
  methods: {
    ...urlFormat,
    displayMovie(item) {
      this.$store.commit("player/set_video_dialog", {
        visible: true,
        src: this.getVideoStreamUrl(item.id, item.token),
        token: item.token,
        element: item.element,
      });
    },
    clearSearch() {
      this.searching = false;
      this.$store.commit("search/set_term", "");
    },
    searchVideos() {
      if (this.search && this.search.length === 0) {
        return this.clearSearch();
      }
      this.searching = true;

      let payload = {
        term: this.search.toLowerCase(),
      };
      if (this.element) payload.element = this.element;
      this.$store.dispatch("search/SEARCH_VIDEO_ASSETS", payload);
    },
    searchTermChanged() {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.q = this.search.toLowerCase();
      this.$router.replace({ query: queries });
      this.$store.commit("search/set_term", this.search);
      if (this.search.length > 2) {
        this.searchVideos();
      } else if (this.search.length == 0) {
        this.clearSearch();
      }
    },
  },
  async mounted() {
    if (this.allVideos.length == 0) {
      this.$store.commit("search/set_loading", true);
      await this.$store.dispatch("clips/FETCH_CLIPS", {
        limit: 12,
      });
      this.$store.commit("search/set_loading", false);
    }
  },
  created() {
    // delay execution of request to reduce number of requests made
    this.searchTermChanged = debounce(this.searchTermChanged, 150);

    if (this.$route.query.q) {
      this.search = this.$route.query.q;
      this.searchTermChanged();
    }
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/style/main'
.searchBtn
  min-height: 48px
.v-toolbar
  position: sticky !important
  top: 0 !important
  z-index: 5
.scrollContainer
  overflow-y: scroll
  max-height: 60vh
</style>
